export function findActiveHeadingId(
  headings: ReadonlyArray<{ id: string; top: number }>,
  threshold: number,
): string | null {
  if (headings.length === 0) {
    return null;
  }

  let activeId: string | null = null;
  for (const heading of headings) {
    if (heading.top <= threshold) {
      activeId = heading.id;
    }
  }

  return activeId ?? headings[0].id;
}
